import React, {Component, Fragment} from 'react';
import {ErrorMessage, Field} from "formik";
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

function shouldShowError(props) {
    return (props.errors[props.name] && _.get(props.touched, props.name));
}

export function NumberField(props) {

    return (
        <Fragment>
            <label htmlFor="account">{props.label}</label>
            <Field type="number"
                   name={props.name}
                   id={props.name}
                   className={'form-control' + (shouldShowError(props) ? ' is-invalid' : '')}
            />
            <div className="invalid-feedback">{props.errors[props.name]}</div>
        </Fragment>
    );
}

export function TextField(props) {

    return (
        <Fragment>
            <label htmlFor="account">{props.label}</label>
            <Field type="text"
                   name={props.name}
                   id={props.name}
                   className={'form-control' + (shouldShowError(props) ? ' is-invalid' : '')}
            />
            <div className="invalid-feedback">{props.errors[props.name]}</div>
            { props.example !== undefined ?
                <p className="text-muted mb-0 mt-2">{props.example}</p>
                :
                ''
            }
        </Fragment>
    );
}

export function PhoneField(props) {

    return (
        <Fragment>
            <label htmlFor={props.name}>{props.label}</label>
            <div className="input-group">
                <div className="input-group-prepend">
                    <div className="input-group-text">+370</div>
                </div>
                <Field type="number"
                       name={props.name}
                       id={props.name}
                       className={'form-control' + (shouldShowError(props) ? ' is-invalid' : '')}
                />
            </div>
            <div className="invalid-feedback definitely-show">{props.errors[props.name]}</div>
        </Fragment>
    );
}

export function SelectField(props) {

    let generateOptions = (options) => {
        let generatedOptions  = [];

        generatedOptions.push(<option value="none" key={0}></option>);
        Object.keys(options).forEach((key, index) => {
            generatedOptions.push(<option value={key} key={index+1}>{options[key]}</option>)
        });

        return generatedOptions;
    };

    let callback = (event) => {
        let values = {};
        values[props.name] = event.target.value;
        props.setFieldValue(props.name, event.target.value);
    };

    return (
        <Fragment>
            <label htmlFor={props.id !== undefined ? props.id : props.name}>{props.label}</label>
            <div className="input-group">

                <select
                       name={props.name}
                       id={props.id !== undefined ? props.id : props.name}
                       className={'form-control' + (shouldShowError(props) ? ' is-invalid' : '')}
                       onChange={callback}
                >
                    {generateOptions(props.options)}
                </select>
            </div>
            <div className="invalid-feedback definitely-show">{props.errors[props.name]}</div>
        </Fragment>
    );
}

export function YesNoRadio(props) {
    const { t, i18n } = useTranslation();

    let callback = (event) => {
        props.setFieldValue(props.name, event.target.attributes['data-part'].value === 'true');
    };

    let getYesLabel = () => {
        if (props.yes_label !== undefined) {
            return props.yes_label;
        }

        return t('forms.yes');
    };

    let getNoLabel = () => {
        if (props.no_label !== undefined) {
            return props.no_label;
        }

        return t('forms.no');
    };

    return (
        <Fragment>
            <div className="mb-3">{props.label}
            </div>
            <div className="d-flex">
                <div className="form-group mr-4">
                    <div className="custom-control custom-radio">
                        <input type="radio"
                               id={props.name + '_yes'}
                               name={props.name}
                               className="custom-control-input"
                               data-part={true}
                               checked={_.get(props.values, props.name)}
                               onChange={callback}
                        />
                        <label className="custom-control-label"
                               htmlFor={props.name + '_yes'}>{getYesLabel()}</label>
                    </div>
                </div>
                <div className="form-group">
                    <div className="custom-control custom-radio">
                        <input type="radio"
                               id={props.name + '_no'}
                               name={props.name}
                               className="custom-control-input"
                               data-part={false}
                               checked={! _.get(props.values, props.name)}
                               onChange={callback}
                        />
                        <label className="custom-control-label"
                               htmlFor={props.name + '_no'}>{getNoLabel()}</label>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export function Checkbox(props) {

    function callback(event) {
        props.setFieldValue(props.name, event.target.checked);
    }

    return (
        <Fragment>
            <div className="custom-control custom-checkbox mt-3">
                <input type="checkbox"
                       className="custom-control-input"
                       id={props.name}
                       name={props.name}
                       checked={props.values[props.name]}
                       onChange={callback}
                />
                <label className="custom-control-label" htmlFor={props.name}>
                    { props.label }
                </label>
                <div className="invalid-feedback definitely-show">{props.errors[props.name]}</div>
            </div>
        </Fragment>
    );
}


